import { AbstractCustomRuleFormSectionWebComponent } from '../../AbstractCustomRuleFormSectionWebComponent';
import { IntegrityMonitorRegistryValueRuleFormController } from '../controller/IntegrityMonitorRegistryValueRuleFormController';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Rights } from '@nirvana/shared/constants';

export class IntegrityMonitorRegistryValueRuleFormWebComponent extends AbstractCustomRuleFormSectionWebComponent {
  public controller!: IntegrityMonitorRegistryValueRuleFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRegistryValueRuleFormController,
    });
  }

  public get value(): any {
    return this.controller.view.formGroup.value;
  }

  public get valid(): boolean {
    return this.controller.view.formGroup.valid && this.controller.view.dom.$actionsForm.valid;
  }

  public get valid$(): Observable<boolean> {
    return combineLatest([this.controller.view.formGroup.valid$, this.controller.view.dom.$actionsForm.valid$]).pipe(
      map(([a, b]) => a && b)
    );
  }

  public reset(): void {
    this.controller.resetFields();
  }

  public setData(ruleData: any): void {
    this.controller.view.formGroup.value = ruleData;
    if (!Application.Main.hasAllRights([Rights.MANAGE_POLICIES_WRITE])) {
      this.controller.view.formGroup.setDisabled(true);
    }
    this.controller.view.dom.$actionsForm.setData(ruleData.attributes);
  }
}
